export enum SearchType {
  PROPERTY = 'Property',
  CUSTOMER = 'Customer',
  RECEIPT = 'Receipt',
}
